// tslint:disable:trailing-comma
export var legacyRoutes = [
    {
        name: 'Auto DEF Del Failures',
        path: '/Shepherd2/AutoDeliverFailures.aspx',
        redirect: '/legacy/AutoDeliverFailures.aspx',
        meta: {
            includeInMenu: true,
            authorize: '$_AUTO_DEF_DEL_FAILURES',
        },
    },
    {
        name: 'Claims Tracker',
        path: "/Shepherd2/ClaimsMaster.aspx",
        redirect: '/legacy/ClaimsMaster.aspx',
        meta: {
            includeInMenu: true,
            authorize: '$_CLAIMS_TRACKER',
        },
    },
    {
        name: 'Create Voyage',
        path: "/Shepherd2/CreateVoyage.aspx",
        redirect: '/legacy/CreateVoyage.aspx',
        meta: {
            includeInMenu: true,
            authorize: '$_CREATE_VOYAGE',
        },
    },
    {
        name: 'Fuel Tank Monitoring',
        path: "/Shepherd2/TankMonitoring.aspx",
        redirect: '/legacy/TankMonitoring.aspx',
        meta: {
            includeInMenu: true,
            authorize: '$_FUEL_TANK_MONITORING',
        },
    },
    {
        name: 'Inventory List',
        path: "/Shepherd2/InventoryList.aspx",
        redirect: '/legacy/InventoryList.aspx',
        meta: {
            includeInMenu: true,
            authorize: '$_INVENTORY_LIST',
        },
    },
    {
        name: 'Inventory Monitoring',
        path: "/Shepherd2/InventoryMonitoring.aspx",
        redirect: '/legacy/InventoryMonitoring.aspx',
        meta: {
            includeInMenu: true,
            authorize: '$_INVENTORY_MONITORING',
        },
    },
    {
        name: 'Load List',
        path: "/Shepherd2/LoadList.aspx",
        redirect: '/legacy/LoadList.aspx',
        meta: {
            includeInMenu: true,
            authorize: '$_LOAD_LIST',
        },
    },
    {
        name: 'Load Details',
        path: "/Shepherd2/LoadList2.aspx",
        redirect: '/legacy/LoadList2.aspx',
        meta: {
            authorize: '$_LOAD_LIST',
        },
    },
    {
        name: 'Missing Inventory',
        path: "/Shepherd2/MissingInventoryList.aspx",
        redirect: '/legacy/MissingInventoryList.aspx',
        meta: {
            includeInMenu: true,
            authorize: '$_MISSING_INVENTORY',
        },
    },
    {
        name: 'Short Term Blocks',
        path: "/Shepherd2/ShortTermBlock.aspx",
        redirect: '/legacy/ShortTermBlock.aspx',
        meta: {
            includeInMenu: true,
            authorize: '$_SHORT_TERM_BLOCKS',
        },
    },
    {
        name: 'Source List',
        path: "/Shepherd2/SourceList.aspx",
        redirect: '/legacy/SourceList.aspx',
        meta: {
            includeInMenu: true,
            authorize: '$_SOURCE_LIST',
        },
    },
    {
        name: 'ZFIR Imbalance',
        path: "/Shepherd2/ZFIRImbalance.aspx",
        redirect: '/legacy/ZFIRImbalance.aspx',
        meta: {
            includeInMenu: true,
            authorize: '$_ZFIR_IMBALANCE',
        },
    },
];
